import React from "react";
import { useTranslation } from "react-i18next";

import Modal from "../Modal";
import Button from "../../Shared/Button";
import styles from "./ErrorModal.module.css";
import { useErrorModal } from "../../context/errorModal";
import { errorModalTitle, resolveUserMessage } from "../../utils/errorMessages";

/**
 * Single app-wide modal for API failures. Mounted once; it reads whatever the
 * error context is currently holding, so nothing needs to pass it props.
 */
export function ErrorModal() {
  const { t } = useTranslation();
  const context = useErrorModal();
  const error = context?.error;
  const clearError = context?.clearError;

  if (!error) return null;

  const { key, fallback, serverText } = resolveUserMessage(error);
  const message = serverText ?? t(key, fallback);
  const title = t(errorModalTitle.key, errorModalTitle.fallback);

  return (
    <Modal isOpen onClose={clearError}>
      <div
        className={styles.content}
        role="alertdialog"
        aria-modal="true"
        aria-label={title}
      >
        <span className={styles.title}>{title}</span>
        <span className={styles.body}>{message}</span>
      </div>
      <div className={styles.buttonBox}>
        <Button onClick={clearError} text={t("Okay")} className="closeBtn" />
      </div>
    </Modal>
  );
}

export default ErrorModal;
